(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

function initCarousels(container) {
    var containers = container
      ? container.querySelectorAll('.pgslider-wrapper-main')
      : document.querySelectorAll('.pgslider-wrapper-main');

    containers.forEach(function (iav) {
      if (iav.dataset.carouselInit) return;
      iav.dataset.carouselInit = 'true';

      var track = iav.querySelector('.pgslider-track-main');
      var slides = iav.querySelectorAll('.pgslider-slide-item');
      var next = iav.querySelector('.iav-next-btn');
      var prev = iav.querySelector('.pgslider-control-prev');
      var scrollbar = iav.querySelector('.pgslider-indicator-bar');
      var scrollThumb = iav.querySelector('.pgslider-indicator-thumb');
      var index = 0;

      function update() {
        track.style.transform = 'translateX(' + -index * 100 + '%)';
        updateScrollbar();
      }

      function updateScrollbar() {
        if (window.innerWidth <= 480 && scrollbar && scrollThumb) {
          var thumbWidth = 100 / slides.length;
          var thumbPosition = index * thumbWidth;
          scrollThumb.style.width = thumbWidth + '%';
          scrollThumb.style.left = thumbPosition + '%';
        }
      }

      if (next)
        next.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          index = (index + 1) % slides.length;
          update();
        });

      if (prev)
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          index = (index - 1 + slides.length) % slides.length;
          update();
        });

      let startX = 0;

      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      });

      track.addEventListener('touchend', function (e) {
        let endX = e.changedTouches[0].clientX;

        if (startX - endX > 50) {
          index = (index + 1) % slides.length;
        } else if (endX - startX > 50) {
          index = (index - 1 + slides.length) % slides.length;
        }

        update();
      });

      if (scrollbar) {
        scrollbar.addEventListener('click', function (e) {
          if (window.innerWidth <= 480) {
            var rect = scrollbar.getBoundingClientRect();
            var clickX = e.clientX - rect.left;
            var percentage = clickX / rect.width;
            index = Math.floor(percentage * slides.length);
            if (index >= slides.length) index = slides.length - 1;
            update();
          }
        });
      }

      window.addEventListener('resize', function () {
        updateScrollbar();
      });

      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCarousels();
  });

  } catch(e) { console.error(e); }
})();
})();
